import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { AddMoreCouponCodes } from "@/features/CouponCodes/Csv/AddMoreCouponCodes";

const searchSchema = z.object({
  offerSlug: z.string().min(1),
});

export const Route = createFileRoute(
  "/_auth/settings/$siteId/coupon-codes/add-codes",
)({
  validateSearch: zodValidator(searchSchema),
  component: AddMoreCouponCodes,
});
